/* eslint-disable import/prefer-default-export */
import { Vendors } from "theme";

export const USER_PLATFORM: Record<Vendors, string> = {
	vi: "VI Microsite",
	apna: "Apna Main Website",
};
